export const userSelector = (state) => state.userReducer.user;
export const allSelector = (state) => state.userReducer.all;

//
export const usersSelector = (state) => state.userReducer.users;
